import { AppConfig } from 'app.config';
import { GenericRequest } from "data-layer/types";

export const LocalizationRequestService = (lang: string): GenericRequest => ({
  url: AppConfig.localizationUrl!,
  method: AppConfig.useDummyData ? 'GET' : 'POST',
  data: { lang },
});
